import React, { useEffect, useState } from "react";
import { Pie } from "@ant-design/plots";

const PieChartLand = (props) => {
  const [ data, setData ] = useState();

  useEffect(() => {
    if(props.data){
      const filteredData = props.data.filter((p) => p.sales !== 0).map((type) => {
        return {
          ...type,
          sales: Number(type.sales),
        };
      });
      setData(filteredData);
    }
  }, [props]);

  const config = {
    appendPadding: 0,
    data: data || [],
    angleField: "sales",
    colorField: "type",
    color: ({ type }) => {
      switch (type) {
        case "Disponíveis":
          return "#20B2AA"; // Cor para 'Disponíveis'
        case "Indisponíveis":
          return "#f5222d"; // Cor para 'Indisponíveis'
        default:
          return "#d9d9d9";
      }
    },
    radius: 0.8,
    label: {
      type: "inner",
      content: "{percentage}",
      autoRotate: true,
      style: {
        fontSize: 10,
        margin: "0px 5px 0px 10px",
      },
    },
    interactions: [
      {
        type: "pie-legend-active",
      },
      {
        type: "element-active",
      },
    ],
    animation: false,
    height: 200,
  };
  return <Pie {...config} />;
};

export default PieChartLand;
